'use strict';

/**
 * Fill data-cuid attributes.
 * @param {string} clientId - Client id.
 */
function setAttributeValues(clientId) {
    const elements = document.querySelectorAll('.uni-tag, #unisize_cv_tag');

    for (let i = 0; i < elements.length; i += 1) {
        elements[i].setAttribute('data-cuid', clientId);
    }
}

/**
 * Set client id.
 * @returns {Promise} - Will resolve when Tealium data is loaded.
 */
function setClientId() {
    const time = Date.now();

    return new window.Promise((resolve) => {
        const check = () => {
            if (window.utag_data) {
                const data = window.utag_data;
                const clientId = String(data.user_registered) === 'true' && typeof data.ecbeing_guid === 'string'
                    ? data.ecbeing_guid
                    : '';
                setAttributeValues(clientId);
                resolve();
                return;
            }

            if (Date.now() - time > 3500) {
                resolve();
                return;
            }

            setTimeout(check, 300);
        };

        check();
    });
}

module.exports = {
    init: function () {
        // If unisize enabled, inject unsize product tag
        const pdpTag = document.getElementById('unisize_tag');
        if (pdpTag) {
            setClientId().then(() => {
                const script = document.createElement('script');
                script.type = 'text/javascript';
                script.src = 'https://bnr.cl.unisize.makip.co.jp/tag/unisize.js';
                document.body.appendChild(script);
            });
        }

        // if unisize enabled, inject purchase history tag
        const orderConfirmTag = document.getElementById('unisize_cv_tag');
        if (orderConfirmTag) {
            setClientId().then(() => {
                const script = document.createElement('script');
                script.type = 'text/javascript';
                script.src = 'https://cl.unisize.makip.co.jp/view/unisize_cv_tag.js?v=' + new Date().getTime();
                document.body.appendChild(script);
            });
        }
    }
};
